const ROUTE_PATHS = {
  HOME: "/",
  WSM_SIGNIN: "/sign-in",
  WSM_INITIAL_LOAD: "/loading",
  WSM_HOME: "/home",
  WSM_CALENDAR: "/calendar",
  WSM_RESERVATIONS: "/calendar/reservations",
};

export default ROUTE_PATHS;
